<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/daFvWr/tc-custom/9781035831920.jpg?1718106504315" alt="This image is the cover for the book Who Wants to Live Forever"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Who Wants to Live Forever
      </h1>
      <p class="bookDescription body article font2">
        <p>In his younger days, mysteries consumed him. The allure of Agatha Christie’s intricate plots kept him engrossed for hours, as he delved into each twist and turn. Drawing from the vibrant tapestry of his own life – rich, thrilling, and ever-evolving – he crafted a narrative that seamlessly blends his experiences with fiction. While firmly rooted in reality, he infused the tale with creative embellishments, taking full advantage of artistic liberty. After sharing the initial draft with close friends, the overwhelming response was one of surprise, particularly at the story’s unexpected climax. Dive in, and let his journey surprise you too.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Evans
      </h2>
      
      <p class="authorDescription body article">Paul’s main loves have always been family, friends, music, reading and travel. He had always wanted to write a novel, but at the same time, was always too busy. Finally, in his later years, Paul has been able to write his first book. He hopes to write more soon, each under the titles of Queen songs, in memory of his favourite band. I hope you enjoy it…</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?522318a4